import type { AppProps } from "next/app";
import React, { useEffect, useMemo, useState } from "react";
import { SwiggyHeadersContext } from "@swiggy-private/generic-mxn-context/dist";
import { FontStyle } from "@swiggy-private/dls-web-theme/dist/components/Fonts";
import ErrorBoundary from "@swiggy-private/aatm-nirbhar-ui/dist/ErrorBoundary";
import GlobalStyled from "@swiggy-private/aatm-nirbhar-ui/dist/GlobalStyled";
import { CACHE_POSTFIX } from "@swiggy-private/aatm-nirbhar-build/dist/constants/htmlCaching";
import { ThemeProvider } from "@swiggy-private/dls-web-theme/dist/components/ThemeProvider";
import { BaseTheme } from "@swiggy-private/dls-web-common/dist/components/themes/Base";
import { Sdk, useBootstrap } from "../hooks/useBootstrap";
import { getAnalyticsContextValue } from "../utils/analytics";
import { WidgetControllerContext } from "@swiggy-private/dls-react-mxn/dist";
import { getSwiggyHeaders } from "../utils/bridgeSdk";
import { GetSwiggyHeadersResponsePayload } from "@swiggy-private/native-bridge/dist/interfaces";

function MyApp({ Component, pageProps, router }: AppProps) {
    // Detect if the page is a cached version
    const isCached = router.route.includes(CACHE_POSTFIX);
    useBootstrap("portal_static_page", isCached);
    const [headers, setHeaders] = useState<GetSwiggyHeadersResponsePayload>();
    const contextValue = useMemo(() => {
        const analyticsContext = getAnalyticsContextValue(headers);
        return {
            sdk: Sdk,
            impressionAnalytics: analyticsContext.impressionEvent,
            clickAnalytics: analyticsContext.clickEvent,
            headers,
        };
    }, [headers]);

    useEffect(() => {
        let headersResponse;
        async function fetchData() {
            try {
                if (headers) {
                    return;
                }
                headersResponse = await getSwiggyHeaders();

                setHeaders(headersResponse);
            } catch (err) {}
        }
        fetchData();
    }, [headers]);

    return (
        <ErrorBoundary dsn="https://331e1f186ac146ee85416c49b47821fb@o331401.ingest.sentry.io/4505092203741184">
            <ThemeProvider theme={BaseTheme} colorMode="light">
                <GlobalStyled />
                <FontStyle />
                <SwiggyHeadersContext.Provider value={{ headers }}>
                    <WidgetControllerContext.Provider value={contextValue}>
                        <Component {...pageProps} />
                    </WidgetControllerContext.Provider>
                </SwiggyHeadersContext.Provider>
            </ThemeProvider>
        </ErrorBoundary>
    );
}

export default MyApp;
